import React, { useEffect, useState } from "react";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import "./AccommodationOverviewPage.scss";
import Email from "../../assets/email-icon.png";
import Phone from "../../assets/phone-icon.png";
import type { MenuProps } from "antd";
import { Menu } from "antd";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import BasicInformation from "./BasicInformation/BasicInformation";
import { getAccommodation } from "../../services/AccommodationService";
import { useLocation, useParams } from "react-router-dom";
import RoomsPage from "./RoomsPage/RoomsPage";
import Participants from "./Participants/Participants";
import { AxiosResponse } from "axios";
import { getAccommodationInEvent } from "../../services/EventService";

const AccommodationOverviewPage = (props: any) => {
  const { setBreadcrumb } = useApplicationContext();
  const [current, setCurrent] = useState("1");
  const { id, accommodationId } = useParams();
  const data = useParams();
  const [inputData, setInputData] = useState<any>({});
  const [oneAccommodation, setOneAccommodation] = useState();
  const [oneEvent, setOneEvent] = useState<any>();
  const [loadEvent, setLoadEvent] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const { accommodation } = location?.state || {};
    const { event } = location?.state || {};

    if (!id) return;
    if (!accommodationId) return;
    getAccommodationInEvent(id, accommodationId).then((res: any) => {
      setOneAccommodation(res.data.result?.accommodation);
      setOneEvent(res.data.result?.event);
      setInputData(res.data.result?.accommodation);
    });
  }, [id, accommodationId, loadEvent]);

  const items: MenuProps["items"] = [
    {
      label: "Učesnici",
      key: "1",
      icon: <UserOutlined />,
    },
    {
      label: "Osnovni podaci",
      key: "2",
      icon: <HomeOutlined />,
    },
  ];

  useEffect(() => {
    // setBreadcrumb(["Smeštaj", "Lista smeštaja", inputData.name ?? ""]);
  }, [inputData]);

  const onClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
  };

  const changeCurrentActive = () => {
    setLoadEvent(!loadEvent);
  };

  return (
    <PageLayout>
      {oneEvent && (
        <div className="accommodation-overview">
          <div className="overview-header">
            <div className="overview-header-left">
              <i className="bi bi-houses circle-i-acc"></i>
              <div className="header-box">
                <p className="header">{inputData?.name}</p>
                <div className="contact-data">
                  <div className="mail-box">
                    <img alt="" src={Email} />
                    <p>{inputData?.webAddress}</p>
                  </div>
                  <div className="phone-box">
                    <img alt="" src={Phone} />
                    <p>{inputData?.receptionContactPhone}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="overview-header-right">
              <p className="legend-text">Legenda:</p>
              <div className="legend-row">
                <i
                  className="bi bi-houses"
                  style={{
                    fontSize: "1.4rem",
                    color: "#C7363D",
                    paddingRight: "0.4rem",
                  }}
                ></i>
                <p className="red">Popunjeno</p>
              </div>
              <div className="legend-row">
                <i
                  className="bi bi-houses"
                  style={{
                    fontSize: "1.4rem",
                    color: "#FABC29",
                    paddingRight: "0.4rem",
                  }}
                ></i>
                <p className="yellow">Rezervisano</p>
              </div>
              <div className="legend-row">
                <i
                  className="bi bi-houses"
                  style={{
                    fontSize: "1.4rem",
                    color: "#52C41A",
                    paddingRight: "0.4rem",
                  }}
                ></i>
                <p className="green">Slobodno</p>
              </div>
            </div>
          </div>
          <div className="menu">
            <Menu
              onClick={onClick}
              selectedKeys={[current]}
              mode="horizontal"
              items={items}
            />
            {current === "1" && (
              <Participants
                data={inputData}
                event={oneEvent}
                changeCurrentActive={changeCurrentActive}
              />
            )}
            {current === "2" && <BasicInformation data={inputData} />}
          </div>
        </div>
      )}
    </PageLayout>
  );
};

export default AccommodationOverviewPage;
